<template>
  <footer class="app-layout-footer" :class="{ fixed }">
    <slot />
  </footer>
</template>

<script>
export default {
  name: 'AppLayoutFooter',

  data() {
    return {
      modalElement: undefined,
    }
  },

  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';

$borderRadius: 25px;

.app-layout-footer {
  // min-width: 100vw;
  // max-width: 100vw;
  width: 100%;
  z-index: 3;
  // padding: $defaultPadding;
  // background-color: var(--primary-color);
  // border-radius: $borderRadius $borderRadius 0 0;
  // margin-top: $defaultPadding;
  position: relative;

  &.fixed {
    border-radius: $borderRadius $borderRadius 0 0;
    position: sticky;
    bottom: 0;
    width: 100%;
    z-index: 4;
    margin-top: 1.5rem;

    > .app-card {
      &.transparent {
        padding-top: 0;
      }
    }

    :deep(.app-button) {
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.75);
    }
  }
}
</style>
